import {
  type IDateDropdownContentItem,
  type IMainDropdownContentItem,
  SearchDateEnum,
  SearchTypesEnum,
} from 'widgets/SearchDropdown/model/types'

export const mainDropdownContentItems: IMainDropdownContentItem[] = [
  {
    id: 1,
    label: 'Contact',
    icon: 'users',
    type: SearchTypesEnum.contacts,
  },
  {
    id: 2,
    label: 'Tag',
    icon: 'tag',
    type: SearchTypesEnum.tags,
  },
  {
    id: 3,
    label: 'Inbox',
    icon: 'all_inboxes',
    type: SearchTypesEnum.teams,
  },
  {
    id: 4,
    label: 'Member',
    icon: 'userFilled',
    type: SearchTypesEnum.members,
  },
  {
    id: 5,
    label: 'Created date',
    icon: 'calendar',
    type: SearchTypesEnum.date,
  },
  {
    id: 6,
    label: 'Segment',
    icon: 'segment',
    type: SearchTypesEnum.segment,
  },
  {
    id: 7,
    label: 'Assignee',
    icon: 'userFilled',
    type: SearchTypesEnum.assignee,
  },
  {
    id: 8,
    label: 'Number',
    icon: 'phone',
    type: SearchTypesEnum.numbers,
  },
  {
    id: 9,
    label: 'Outbound source',
    icon: 'send',
    type: SearchTypesEnum.outbound_sources,
  },
  {
    id: 10,
    label: 'Time',
    icon: 'clock',
    type: SearchTypesEnum.time_range,
  },
]

export const dateDropdownContentItems: IDateDropdownContentItem[] = [
  {
    id: 1,
    label: 'Today',
    type: SearchDateEnum.today,
  },
  {
    id: 2,
    label: 'Yesterday',
    type: SearchDateEnum.yesterday,
  },
  {
    id: 3,
    label: 'Last 30 days',
    type: SearchDateEnum.last30days,
  },
  {
    id: 4,
    label: 'Last 90 days',
    type: SearchDateEnum.last90days,
  },
  {
    id: 5,
    label: 'Custom',
    type: SearchDateEnum.custom,
  },
]
